import { UnicodeEntity } from '@mews/enums';
import { Body, Stack, StackItem } from '@optimus-web/core';
import { LocalizedNumber } from '@mews/framework';
import { NumberWrapper } from './styles';

interface SummaryRowBodyProps {
    count: number;
    text: React.ReactNode;
}

const SummaryRowBody = ({ count, text, ...other }: SummaryRowBodyProps) => (
    <Stack spacing="200" {...other}>
        <StackItem padding="0">
            <NumberWrapper variant="secondary" as="div">
                <LocalizedNumber number={count} data-test-row-count />
                {UnicodeEntity.MultiplicationSign}
            </NumberWrapper>
        </StackItem>
        <StackItem padding="0">
            <Body size="small" data-test-row-label>
                {text}
            </Body>
        </StackItem>
    </Stack>
);

export default SummaryRowBody;
